// toast.js
// Aviso estándar de "se guardó" / "no se pudo guardar" para toda la app —
// lo escucha GlobalToast.jsx (el mismo Snackbar que ya usa el interceptor de
// axios para errores de transporte). Reemplaza los Alert/Snackbar locales
// que cada pantalla armaba a su manera.

export const avisar = (message, severity = 'success') => {
  window.dispatchEvent(new CustomEvent('app-toast', { detail: { message, severity } }));
};

export const avisarExito = (message) => avisar(message, 'success');
export const avisarError = (message) => avisar(message, 'error');
export const avisarAdvertencia = (message) => avisar(message, 'warning');
export const avisarInfo = (message) => avisar(message, 'info');
